export class Contact {
	id: number;
	company_id: number;
	title: string;
	firstname: string;
	lastname: string;
	tutoyeren: boolean;
	salutation: string;
	function_description: string;
	gender: string;
	language: string;
	email: string;
	website: string;
	telephone: string;
	telephone2: string;
	fax: string;
	classification_id: number;
	mailinglist: boolean;
	financial_contact: boolean;
	on_account: boolean;
	discount: number;
	status: number;
	has_login: boolean;
	login_email: string;
	login_password: string;
	billing_address: string;
	billing_zipcode: string;
	billing_city: string;
	billing_province_id: string;
	billing_country_id: string;
	delivery_address: string;
	delivery_zipcode: string;
	delivery_city: string;
	delivery_province_id: string;
	delivery_country_id: string;
	comments: string;
	user_created_id: number;
	user_modified_id: number;
	created_at: string;
	updated_at: string;

	user_created: string;
	user_modified: string;
	company: string;

	send_email: boolean;

	subclassifications: number[];
	subclassification_names: string[];

	constructor() {
		this.id = 0;
		this.send_email = false;
	}
}



// WEBPACK FOOTER //
// /var/www/vhosts/vinologiwijnen.nl/httpdocs/crm/resources/assets/src/app/shared/models/crm/contact.ts